import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector } from 'react-redux';
import WYSIWYGEditor from '../Common/WYSIWYGEditor';

const ModalCrearPlantilla = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({ name: '', content: '' });
    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        formData.tenantId = tenantId
        formData.empresa = empresa
        onSave(formData);
        setFormData({ name: '', content: '' }); // Reset
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Crear Plantilla</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="name">Nombre</Label>
                        <Input type="text" name="name" id="name" value={formData.name} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="content">Contenido</Label>
                        <WYSIWYGEditor
                            value={formData.content}
                            onChange={(value) => setFormData({ ...formData, content: value })}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearPlantilla;